import { Link } from '@loomhq/lens';
import React from 'react';

import {
  ORG_ROLE_ADMIN,
  ORG_ROLE_CREATOR_LITE,
} from 'constants/organizationRoles';
import { MANAGE_MEMBERS } from 'constants/routes';
import {
  WORKSPACE_PLAN_BUSINESS,
  WORKSPACE_PLAN_DISPLAY_NAME_MAP,
  WORKSPACE_PLAN_HIERARCHY,
  WORKSPACE_PLAN_INDEFINITE_ARTICLE_MAP,
  WORKSPACE_PLAN_STARTER_FREE,
} from 'constants/workspacePlans';
import { UPGRADE_TYPES } from 'constants/workspaceUpgradeRequests';

export const getUpgradeType = ({ selectedWorkspace, minPlanForFeature }) => {
  if (
    selectedWorkspace?.memberRole !== ORG_ROLE_CREATOR_LITE ||
    selectedWorkspace?.type == WORKSPACE_PLAN_STARTER_FREE
  ) {
    return UPGRADE_TYPES.PLAN;
  }

  return WORKSPACE_PLAN_HIERARCHY[minPlanForFeature] >
    WORKSPACE_PLAN_HIERARCHY[selectedWorkspace.type]
    ? UPGRADE_TYPES.PLAN
    : UPGRADE_TYPES.ROLE;
};

export const getTooltipMessage = ({
  selectedWorkspace,
  minPlanForFeature = WORKSPACE_PLAN_BUSINESS,
  requestStatus = null,
}) => {
  if (requestStatus !== null) {
    return (
      <>
        We let your admin(s) know of your upgrade request. To see a full list of
        admin(s), visit the{' '}
        <Link href={MANAGE_MEMBERS} variant="neutral">
          Workspace members
        </Link>{' '}
        page.
      </>
    );
  }

  const upgradeType = getUpgradeType({ selectedWorkspace, minPlanForFeature });

  if (upgradeType === UPGRADE_TYPES.ROLE) {
    return (
      <>
        This feature is only available for the <strong>Creator</strong> role.
        Click to request to your admin(s) to upgrade your role from{' '}
        <strong>Creator Lite</strong> to <strong>Creator</strong>.
      </>
    );
  }

  const planName = WORKSPACE_PLAN_DISPLAY_NAME_MAP[minPlanForFeature];
  const planArticle = WORKSPACE_PLAN_INDEFINITE_ARTICLE_MAP[minPlanForFeature];
  const isAdmin = selectedWorkspace?.memberRole === ORG_ROLE_ADMIN;

  return (
    <>
      This feature is only available with {planArticle}{' '}
      <strong>{planName} plan</strong> or above.{' '}
      {isAdmin ? (
        <>Click to upgrade.</>
      ) : (
        <>Send a request to your admin(s) to upgrade.</>
      )}
    </>
  );
};
